import Vue from "vue";

export default {
    resetStateMutation(state) {
        Vue.set(state, "gridIsOpen", true);
        Vue.set(state, "formIsOpen", false);
    },
    setGridOpen(state) {
        state.formIsOpen = false;
        state.gridIsOpen = true;
        state.dataAssInvFormIsOpen = false;
        state.dataAssInvGridIsOpen = false;
    },

    setDataAssInvFormOpen(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.dataAssInvFormIsOpen = true;
        state.dataAssInvGridIsOpen = false;
    },
    setDataAssInvGridOpen(state) {
        state.formIsOpen = false;
        state.gridIsOpen = false;
        state.dataAssInvFormIsOpen = false;
        state.dataAssInvGridIsOpen = true;
    }
}
